import { buildPath } from "../../../helpers/string";
import { PermissionEnum } from "../../../modules/permission/enum";
import { root } from "./root";

export const queue = {
  path: "queue",
  getLink: () => buildPath([root.path, queue.path]),
  permissions: [PermissionEnum.REVIEW_APPLICATIONS_ACCESS, PermissionEnum.INVESTIGATE_APPLICATIONS_ACCESS],
  details: {
    path: ":queueId",
    getLink: (queueId: string | number) => buildPath([queue.path, queueId.toString()]),
    permissions: [PermissionEnum.REVIEW_APPLICATIONS_ACCESS, PermissionEnum.INVESTIGATE_APPLICATIONS_ACCESS],
    applicationDetails: {
      path: "application/:applicationId",
      getLink: (queueId: string | number, applicationId: string | number) =>
        buildPath([queue.details.getLink(queueId), "application", applicationId.toString()]),
      permissions: [PermissionEnum.REVIEW_APPLICATIONS_ACCESS, PermissionEnum.INVESTIGATE_APPLICATIONS_ACCESS],
    },
    disclosureDetails: {
      path: "disclosure/:disclosureId",
      getLink: (queueId: string | number, disclosureId: string | number) =>
        buildPath([queue.details.getLink(queueId), "disclosure", disclosureId.toString()]),
      permissions: [PermissionEnum.REVIEW_APPLICATIONS_ACCESS, PermissionEnum.INVESTIGATE_APPLICATIONS_ACCESS],
      profile: {
        path: "profile",
        getLink: (queueId: string | number, disclosureId: string | number) =>
          buildPath([queue.details.disclosureDetails.getLink(queueId, disclosureId), "profile"]),
        permissions: [PermissionEnum.REVIEW_APPLICATIONS_ACCESS, PermissionEnum.INVESTIGATE_APPLICATIONS_ACCESS],
      },
      additionalSharedFiles: {
        path: "additional-shared-files",
        getLink: (queueId: string | number, disclosureId: string | number) =>
          buildPath([queue.details.disclosureDetails.getLink(queueId, disclosureId), "additional-shared-files"]),
        permissions: [PermissionEnum.REVIEW_APPLICATIONS_ACCESS, PermissionEnum.INVESTIGATE_APPLICATIONS_ACCESS],
      },
      section: {
        path: "section/:sectionId",
        getLink: (queueId: string | number, disclosureId: string | number, sectionId: string | number) =>
          buildPath([queue.details.disclosureDetails.getLink(queueId, disclosureId), "section", sectionId.toString()]),
        permissions: [PermissionEnum.REVIEW_APPLICATIONS_ACCESS, PermissionEnum.INVESTIGATE_APPLICATIONS_ACCESS],
      },
    },
  },
};
